import { render, staticRenderFns } from "./year.vue?vue&type=template&id=0813a204"
import script from "./year.vue?vue&type=script&lang=js"
export * from "./year.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0813a204')) {
      api.createRecord('0813a204', component.options)
    } else {
      api.reload('0813a204', component.options)
    }
    module.hot.accept("./year.vue?vue&type=template&id=0813a204", function () {
      api.rerender('0813a204', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/sharing_agreement/terminal_report/table/year.vue"
export default component.exports